export function getCookieHost() {
  let cookieHost = location.host.split('.')
  cookieHost.shift()
  cookieHost = '.' + cookieHost.join('.')
  return cookieHost
}

export function getCookie(name) {
	let c_name = name + "="
	let ca = document.cookie.split(';')
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(c_name) == 0) {
			return c.substring(c_name.length, c.length)
		}
	}
	return ""
}

export function setCookie(name, value) {
	console.log('setcookie')
	let expireDate = new Date()
	expireDate.setMinutes(expireDate.getMinutes() + 15)
  document.cookie = name + "=" + value + ";expires=" + expireDate + ";domain=" + getCookieHost() + ";path=/"
}
